<template>
  <!-- 弹框 -->
  <vh-dialog
    :title="$t('host.k_625001')"
    :visible.sync="dialogBot"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    append-to-body
    class="botDialog"
    width="750px"
  >
    <vh-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      max-height="500"
      :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
    >
      <vh-table-column :label="$t('host.k_625002')" width="80">
        <template slot-scope="scope">
          <div class="flexBox">
            <div class="gift-cover">
              <img :src="scope.row.avatar" alt="" v-parseImgOss="{ url: scope.row.avatar }" />
            </div>
          </div>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('host.k_625003')" width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.nickname }}</span>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('host.k_625004')" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.chat_content }}
        </template>
      </vh-table-column>
      <div class="" slot="empty">
        <NullMode nullType="null" class="search-no-data" :height="60"></NullMode>
      </div>
    </vh-table>
  </vh-dialog>
</template>

<script>
  import NullMode from '@/packages/null-mode';
  import { useChatServer } from 'middle-domain';

  export default {
    name: 'BotDialog',
    props: {
      topic_id: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        tableData: [], // 列表数据
        dialogBot: false,
        topicId: ''
      };
    },
    components: {
      NullMode
    },
    computed: {},
    methods: {
      async getList() {
        const params = {
          topic_id: this.topicId
        };
        const res = await this.chatServer.getBotList(params);
        this.tableData = res.data.list;
      },
      async open(id) {
        this.topicId = id ? id : this.topic_id;
        this.chatServer = useChatServer();
        await this.getList();
        this.dialogBot = true;
      }
    }
  };
</script>

<style lang="less">
  .botDialog {
    .flexBox {
      display: flex;
      align-items: center;
      .name {
        margin-left: 10px;
      }
      .gift-cover {
        display: inline-block;
        width: 40px;
        min-width: 40px;
        height: 40px;
        // margin: 3px 0;
        background: #ffffff;
        border-radius: 50%;
        // border-radius: 4px;
        // border: 1px solid #e6e6e6;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
          border-radius: 50%;
        }
      }
    }
  }
</style>
